<template>
  <LcButton
    class="lottery-clear-numbers-button"
    :class="{ 'no-margin': noMargin }"
    :disabled="isDisabled"
    icon="trash-full"
    size="medium"
    variant="secondary"
    @click="clearNumbers"
  >
    {{ $t('lottery.clearnumbersbutton.label') }}
  </LcButton>
</template>

<script lang="ts" setup>
type LotteryClearNumbersButtonProps = {
  noMargin?: boolean
  playId: string
}

const { playId } = defineProps<LotteryClearNumbersButtonProps>()

const {
  clearPlay,
  getPlayIndex,
  initialStake,
  lotteryId,
  perPlayAddOn,
  plays,
  setSelectedPerPlayAddOn,
  setSelectedStake,
} = usePlaySlip()
const { isNumberLottery, isPickLottery } = useLotteryType(lotteryId)
const { scrollTop } = useScrollUtils()

const isDisabled = computed(() => {
  const playIndex = getPlayIndex(playId)
  if (playIndex < 0) return true

  return !plays.value[playIndex]?.isDirty
})

const clearNumbers = () => {
  if (isNumberLottery.value && perPlayAddOn.value) {
    setSelectedPerPlayAddOn(playId, {
      name: perPlayAddOn.value.name,
      value: '',
    })
  } else if (isPickLottery.value && perPlayAddOn.value) {
    setSelectedPerPlayAddOn(playId, {
      name: perPlayAddOn.value.name,
      value: perPlayAddOn.value.options[0],
    })
    setSelectedStake(playId, initialStake.value)
  }
  clearPlay(playId)
  scrollTop()
}
</script>

<style lang="scss" scoped>
.lottery-clear-numbers-button {
  @include transition-default(opacity, visibility);

  margin: token-v2('size/space/gap/200') 0;
  padding: 0 3rem;

  &.no-margin {
    margin: 0;
  }
}
</style>
